import _ from 'lodash';

import { PRICE_SELECTED, QUOTED, START } from 'pu-data/QuoteSteps';
import defaultParameters from './defaultParameters';
import defaultQuote from './defaultQuote';

// Initial state for the store, including data when returning from cart
const state = {
  loading: false,
  parameters: defaultParameters,
  parametersChanged: false,
  boardConfirmSpecs: false,
  quoteStep: START,
  lineItemId: null,
  destroy: false,
};

if (Spree.quote) {
  state.quote = Spree.quote;
} else {
  state.quote = defaultQuote;
}

if (Spree.quote_parameters) {
  const quote_parameters = Spree.quote_parameters;

  ["bga", "smt", "thru_hole", "qfn"].forEach((key) => {
    if (!quote_parameters[key]) {
      quote_parameters[key] = "0";
    }
  });

  ["lead_free", "double_sided_smt", "double_sided_tht", "class_3_inspection"].forEach((key) => {
    quote_parameters[key] = quote_parameters[key]?.toString();
  });

  quote_parameters["quantities"].forEach((q, i) => {
    quote_parameters["quantities"][i] = q.toString();
  })

  state.parameters = _.assign(defaultParameters, quote_parameters);

  if (Spree.quote_parameters.supplier_selected) {
    state.quoteStep = PRICE_SELECTED;
  } else {
    state.quoteStep = QUOTED;
  }
}

export default state;